class c extends Error {
  url;
  originalError;
  constructor(t, e) {
    super(`fetch failed when requesting the url: "${t}"`), this.url = t, this.originalError = e;
  }
}
class d extends Error {
  url;
  response;
  constructor(t, e) {
    super(`A request to "${t}" received a failed response.`), this.url = t, this.response = e;
  }
}
var u = /* @__PURE__ */ ((r) => (r.PUT = "PUT", r.PATCH = "PATCH", r.DELETE = "DELETE", r.GET = "GET", r.POST = "POST", r))(u || {}), l = /* @__PURE__ */ ((r) => (r.CORS = "cors", r.NO_CORS = "no-cors", r.SAME_ORIGIN = "same-origin", r))(l || {}), f = /* @__PURE__ */ ((r) => (r.Include = "include", r.Omit = "omit", r.SameOrigin = "same-origin", r))(f || {});
async function m(r, t, e) {
  const a = new URL(t, e?.origin ?? window.location.origin);
  r === "GET" && (e?.data?.brand !== void 0 && ["+", "", "%2B", "None"].includes(e.data.brand) && delete e.data.brand, a.search = new URLSearchParams(e?.data).toString());
  let s = "same-origin";
  e?.mode && (s = e.mode);
  const i = {
    Accept: "application/json"
  };
  e?.secureId && (i.Authorization = `secure_id ${e.secureId}`), e?.data instanceof FormData || (i["Content-Type"] = "application/json;charset=UTF-8");
  let n;
  try {
    n = await fetch(a.href, {
      method: r,
      mode: s,
      credentials: e?.credentials,
      headers: i,
      ...r !== "GET" ? h(e?.data) : null
    });
  } catch (o) {
    throw new c(a.href, o);
  }
  if (n.ok)
    return n.json();
  throw new d(a.href, n);
}
function h(r) {
  return r instanceof FormData ? {
    body: r
  } : {
    body: JSON.stringify(r)
  };
}
export {
  l as FETCH_MODE,
  d as FailedResponseError,
  c as FetchError,
  u as REST_VERBS,
  f as RequestCredentialsValue,
  m as restRequest
};
//# sourceMappingURL=index.js.map
